import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ palette, breakpoints, spacing }) =>
  createStyles({
    container: {
      marginBottom: '1.6rem',
      '& table': {
        borderCollapse: 'separate',
        borderSpacing: '0 0.8rem',

        '& thead th': {
          backgroundColor: palette.background.paper,
          paddingTop: 0,
          paddingBottom: 0,
          border: 'none',

          '& .MuiTypography-h3': {
            fontSize: '1.6rem',
          },
          '&:nth-child(2)': {
            minWidth: 215,
          },
        },

        '& tbody td': {
          backgroundColor: palette.background.default,
          paddingTop: spacing(1.2),
          paddingBottom: spacing(1.2),

          '& button': {
            backgroundColor: '#CECFCE',

            '&:hover': {
              backgroundColor: '#a2a3a2',
            },
          },

          '&:first-child': {
            color: 'var(--text-title)',
            borderTopLeftRadius: 5,
            borderBottomLeftRadius: 5,
          },
          '&:last-child': {
            borderTopRightRadius: 5,
            borderBottomRightRadius: 5,
          },

          '&:nth-child(2)': {
            [breakpoints.up('sm')]: {
              maxWidth: '12rem',
            },
          },
        },
      },

      '& .MuiTableCell-root': {
        fontSize: '1.4rem',
        fontFamily: 'Source Sans Pro',
        fontWeight: 'normal',
        borderBottom: 'none',

        '& > strong': {
          fontSize: '1.6rem',
        },
      },
    },
    menu: {
      '& .MuiMenu-list': {
        paddingBottom: '1.8rem',

        '& li': {
          paddingRight: '3rem',
          paddingLeft: '2rem',
          gap: '1rem',
          width: 'fit-content',

          '&:first-child': {
            paddingRight: '1rem',
            marginLeft: 'auto',
            fontSize: '12px',
            paddingTop: 0,

            '&:hover': {
              backgroundColor: 'initial',
            },
          },

          '& span': {
            fontSize: '2rem',
          },
        },
      },
    },
    select: {
      '& .MuiSelect-select.MuiSelect-select': {
        width: 200,
      },
      '& .MuiFilledInput-input': {
        padding: 10,
      },
      '& .MuiSelect-iconOpen': {
        color: palette.text.primary,
      },
    },
    selectMenu: {
      '& .MuiList-padding': {
        padding: 0,
      },
      '& .MuiRadio-root': {
        color: palette.secondary.light,

        '&.Mui-checked': {
          color: palette.text.primary,
        },
      },
    },
  }),
)
